<template>
  <div class="nx-form-captcha">
    <div class="botdetect-captcha" data-captchastylename="NextoreCaptcha"></div>
    <b-form-input
      id="captchaCode"
      class="mt-2"
      v-model="captchaCode"
      @input="emitToken"
      :state="getValidationState(validationContext)"
      aria-label="captcha code"
    />
    <b-form-invalid-feedback>
      {{ validationContext.errors[0] }}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
import "jquery-captcha/dist/jquery-captcha.min.js";

export default {
  props: {
    endPoint: {
      type: String
    },
    value: {
      type: String,
      default: ""
    },
    validationContext: {}
  },
  data() {
    return {
      captcha: null,
      captchaCode: this.value
    };
  },
  mounted() {
    this.captcha = $(this.$el)
      .find(".botdetect-captcha")
      .captcha({
        captchaEndpoint: "/captcha"
      });
  },
  watch: {
    captchaCode(captchaCode) {
      this.$emit("input", captchaCode);
    }
  },
  methods: {
    emitToken() {
      const { captcha, captchaCode } = this;
      const evt = {
        token: captcha.getCaptchaId() + ":" + captchaCode
      };

      this.$emit("change-token", evt);
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    }
  }
};
</script>

<style lang="sass" scoped></style>
